import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help'; 

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');
require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const jzip = require( 'jszip');
window.JSZip = jzip;
require( 'datatables.net-buttons/js/buttons.html5.min' );

var Config = require('../../../config');

class PhenotypesIdentified extends Component {
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.searching = this.searching.bind(this);
        this.getConvokePlace = this.getConvokePlace.bind(this);
        this.setTable = this.setTable.bind(this);
        this.addPhenotypeFilter = this.addPhenotypeFilter.bind(this);
        this.removePhenotypeFilter = this.removePhenotypeFilter.bind(this);

        this.state = {
            // --- FILTROS GENERALES ---
            health_facilities_id: "",
            health_facilities: [],
            convoke_places: [],
            convoke_places_id: "all",
            group: "all",
            rh: "all",
            status: "DISPONIBLE",

            // --- VARIABLES DE FENOTIPOS  ---
            phenotype_list: [],      // Lista cargada del API (Lookups)
            selected_phenotype: [],  // Valor del dropdown temporal
            selected_result: "+",
            phenotype_filters: [],   // Lista de filtros aplicados {id, name, result}
            
            // --- DATA Y UI ---
            listado: [],
            filename: "Reporte_Fenotipos_Identificados",
            count: 0,
            columns: [
                { title: 'Unidad', width: '10%', className: 'dt-center' },
                { title: 'Grupo', width: '10%', className: 'dt-center' }, 
                { title: 'Fenotipos', width: '45%' }, 
                { title: 'Extracción', width: '12%', className: 'dt-center' },
                { title: 'Caducidad', width: '12%', className: 'dt-center' },
                { title: 'Estatus', width: '16%', className: 'dt-center' },
            ],
                        
            // --- UTILS ---
            medical: "",
            date_hour: "",
            show_options: false
        }
    }

    componentWillMount(){
        var medical = JSON.parse(sessionStorage.getItem('medical_staff'));
        this.setState({
            health_facilities_id: sessionStorage.getItem('health_facilities_id'),
            medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
                    (medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
        });
    }

    componentDidMount(){
        // 1. Cargar Centros
        fetch(Config.default.apiGateway.URL+'health_facilities', {
            method: 'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token')
            })
        }).then(res => res.json())
          .then(response => {
              this.setState({ health_facilities: response || [] });
              this.getConvokePlace();
          });

        // 2. Cargar Catálogo de Fenotipos (CORREGIDO: PHENOTYPE_LIST)
        fetch(Config.default.apiGateway.URL+'lookups?type=PHENOTYPE_LIST', { 
            method: 'GET',
            headers: new Headers({
               'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            })
        }).then(res => res.json())
          .then(response => {
              this.setState({ phenotype_list: response || [] });
          });
        
        this.setTable();
    }

    handleChange(e){
        // DETECTAR SI ES MULTI-SELECT
        if (e.target.type === 'select-multiple') {
            const options = e.target.options;
            const value = [];
            for (let i = 0, l = options.length; i < l; i++) {
                if (options[i].selected) {
                    value.push(options[i].value);
                }
            }
            this.setState({ [e.target.name]: value });
        } else {
            // Lógica normal para los otros inputs
            this.setState({ [e.target.name]: e.target.value });
        }

        // Trigger para recargar lugares de colecta
        if(e.target.name === 'health_facilities_id'){
            setTimeout(() => this.getConvokePlace(), 200);
        }
        

    }

    getConvokePlace(){
        let hf = this.state.health_facilities_id === "" ? "all" : this.state.health_facilities_id;
        fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+hf, {
            method: 'GET',
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token')
            })
        }).then(res => res.json())
          .then(response => {
              this.setState({ convoke_places: response || [] });
          });
    }


    addPhenotypeFilter(){
        const { selected_phenotype, selected_result, phenotype_list, phenotype_filters } = this.state;
        
        // Validamos que el array no esté vacío
        if(!selected_phenotype || selected_phenotype.length === 0) return;

        let newFilters = [...phenotype_filters];
        let duplicados = 0;

        // Recorremos todos los IDs seleccionados
        selected_phenotype.forEach(id => {
            // Evitar duplicados
            console.log("selected_phenotype id", id)
            if(!newFilters.some(f => f.key == id)){
                const phObj = phenotype_list.find(a => a.key == id);
                
                if(phObj){
                    newFilters.push({
                        id: id,
                        name: phObj.name, // Nombre (ej. "C")
                        result: selected_result // "+/-"
                    });
                }
            } else {
                duplicados++;
            }
            console.log(newFilters)
        });

        if(duplicados > 0 && newFilters.length === phenotype_filters.length){
            swal('Atención', 'Los fenotipos seleccionados ya estaban en la lista.', 'warning');
        }

        this.setState({
            phenotype_filters: newFilters,
            selected_phenotype: [] // Limpiamos la selección
        });
    }

    removePhenotypeFilter(id){
        console.log("removePhenotypeFilter",id,this.state.phenotype_filters)
        this.setState({
            phenotype_filters: this.state.phenotype_filters.filter(f => f.id !== id)
        });
    }

    searching(){
        this.props.waiting.handleShow('Generando Reporte...');

        // Construcción del Payload con nombres corregidos
        var payload = {
            health_facilities_id: this.state.health_facilities_id,
            convoke_places_id: this.state.convoke_places_id,
            group: this.state.group,
            rh: this.state.rh,
            status: this.state.status,
            // Mapeo corregido: phenotype_id
            phenotypes: this.state.phenotype_filters.map(f => ({
                phenotype_id: f.id, 
                result: f.result
            }))
        };

        fetch(Config.default.apiGateway.URL+'reports/phenotypes_identified', {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: new Headers({
                'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                'Content-Type'  : 'application/json'
            })
        }).then(res => {
            if(res.ok){
                return res.json();
            } else {
                this.props.waiting.handleClose();
                res.text().then(msg => swal('Error', msg, 'error'));
            }
        }).then(response => {
            if(response !== undefined){
                var list = [];
                // Mapeo de respuesta al formato de DataTable
                response.res.map(r => {
                    list.push([
                        r.unit_number,
                        r.group + ' ' + r.rh,
                        r.phenotypes_string,
                        moment(r.extraction_date).format('DD/MM/YYYY'),
                        moment(r.expiry_date).format('DD/MM/YYYY'),
                        r.status
                    ]);
                });

                this.setState({
                    listado: list,
                    count: response.count,
                    show_options: true,
                    date_hour: moment().format('DD/MM/YYYY HH:mm')
                });

                setTimeout(()=>{
                    this.props.waiting.handleClose();
                    this.setTable(); 
                }, 500);
            }
        });
    }

 setTable(){
        this.$el = $(this.el);
        if ($.fn.DataTable.isDataTable(this.el)) {
            this.$el.DataTable().destroy();
        }

        // String de filtros para el reporte impreso
        const filterString = `Centro: ${this.state.health_facilities_id} | Grupo: ${this.state.group} | Fenotipos: ${this.state.phenotype_filters.map(f=>f.name+f.result).join(', ')}`;
        const totalString = `Total Unidades: ${this.state.count}`;

        this.$el.DataTable({
            dom: 'Bfrtip',
            data: this.state.listado,
            columns: this.state.columns,
            paging: false,
            scrollY: "32em",
            scrollX: true,
            info: false,
            searching: false,
            buttons: [
                {
                    extend: 'excelHtml5',
                    title: this.state.filename,
                    messageTop: `Filtros Aplicados - ${filterString}`,
                    messageBottom: totalString 
                },
                {
                    extend: 'pdf',
                    title: this.state.filename,
                    orientation: 'landscape',
                    customize: (doc) => {
                        var tableNode = doc.content.find(e => e.table);
                        if (tableNode) {
                            tableNode.table.widths = ['10%', '8%', '42%', '13%', '13%', '14%'];
                    
                        }

                        doc.content.unshift({
                            image: this.props.header_document,
                            alignment:'center',
                            width: this.props.w_head
                        });
                        
                        doc.content.splice(2, 0, {
                            text: `Reporte Generado: ${this.state.date_hour} \n ${filterString}`,
                            margin: [10,0,0,10],
                            fontSize: 8
                        });

                        doc.content.push({
                            text: totalString,
                            margin: [0, 10, 0, 0], 
                            bold: true,
                            fontSize: 10,
                            alignment: 'right' 
                        });

                        doc.styles.tableHeader.fontSize = 8;
                        doc.defaultStyle.fontSize = 7;
                        
                        doc.footer = {
                            text: this.state.date_hour + '\t-\t' + this.state.medical, 
                            alignment: 'right', 
                            margin: [0, 0, 20, 0]
                        };
                    }
                }
            ]
        });
    }

    render(){
        const {t} = this.props;

        return (
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page">
                        {sessionStorage.getItem('health_facilities_name')} -> Laboratorio -> Fenotipos Identificados
                    </h5>
                </div>
                
                {/* <Help {...this.props} menu={"help_lab"} submenu={"help_phenotypes"} /> */}

                <div className="form-group" style={{paddingLeft:"0.5em"}}>
                    <div className="col-xs-12">
                        <form onSubmit={(e)=>e.preventDefault()}>
                            
                            {/* --- SIDEBAR DE FILTROS (Ancho 4) --- */}
                            <div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0", minHeight: "500px"}}>
                                
                                <div className="form-group">
                                    <span className="span-min">Centro</span>
                                    <select name="health_facilities_id" className="form-control"
                                        value={this.state.health_facilities_id} onChange={this.handleChange}>
                                        <option value="all">TODOS</option>
                                        {this.state.health_facilities.map((h, i) => (
                                            <option key={i} value={h.id}>{h.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <span className="span-min">Lugar de Colecta</span>
                                    <select name="convoke_places_id" className="form-control"
                                        value={this.state.convoke_places_id} onChange={this.handleChange}>
                                        <option value="all">TODOS</option>
                                        {this.state.convoke_places.map((c, i) => (
                                            <option key={i} value={c.id}>{c.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="row">
                                    <div className="col-xs-6 form-group" style={{paddingRight: "2px"}}>
                                        <span className="span-min">Grupo</span>
                                        <select name="group" className="form-control" value={this.state.group} onChange={this.handleChange}>
                                            <option value="all">TODOS</option>
                                            <option value="A">A</option>
                                            <option value="B">B</option>
                                            <option value="AB">AB</option>
                                            <option value="O">O</option>
                                        </select>
                                    </div>
                                    <div className="col-xs-6 form-group" style={{paddingLeft: "2px"}}>
                                        <span className="span-min">RH</span>
                                        <select name="rh" className="form-control" value={this.state.rh} onChange={this.handleChange}>
                                            <option value="all">TODOS</option>
                                            <option value="POSITIVO">+</option>
                                            <option value="NEGATIVO">-</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <span className="span-min">Estatus Unidad</span>
                                    <select name="status" className="form-control" value={this.state.status} onChange={this.handleChange}>
                                        <option value="all">TODOS</option>
                                        <option value="DISPONIBLE">DISPONIBLE</option>
                                        <option value="RESERVADA">RESERVADA</option>
                                        <option value="BLOQUEADA">BLOQUEADA</option>
                                    </select>
                                </div>

                                <hr />
                                
                                {/* --- WIDGET BUILDER DE FENOTIPOS --- */}
                                <div className="panel panel-info">
                                    <div className="panel-heading" style={{padding: "5px 10px", fontSize: "12px"}}>
                                        Filtro de Fenotipos
                                    </div>
                                    <div className="panel-body" style={{padding: "10px"}}>
                                        <div className="form-group">
                                            {/* DROPDOWN CORREGIDO */}
                                            <select name="selected_phenotype" 
                                                className="form-control input-sm"
                                                multiple={true}
                                                style={{height: '150px'}}
                                                value={this.state.selected_phenotype}
                                                onChange={this.handleChange}>
                                                <option value="">Seleccione Fenotipo...</option>
                                                {this.state.phenotype_list.map((p, i) => (
                                                    <option key={i} value={p.key}>{p.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group" style={{display: "flex"}}>
                                            <select name="selected_result" className="form-control input-sm" style={{width: "70%"}}
                                                value={this.state.selected_result} onChange={this.handleChange}>
                                                <option value="+">POSITIVO (+)</option>
                                                <option value="-">NEGATIVO (-)</option>
                                            </select>
                                            <button className="btn btn-success btn-sm" style={{marginLeft: "5px", width: "30%"}}
                                                onClick={this.addPhenotypeFilter}>
                                                <i className="fa fa-plus"></i>
                                            </button>
                                        </div>

                                        {/* Lista de filtros activos (Chips) */}
                                        <div style={{marginTop: "5px", maxHeight: "150px", overflowY: "auto"}}>
                                            {this.state.phenotype_filters.map((f, i) => (
                                                <div key={i} className="label label-primary" 
                                                    style={{display: "block", marginBottom: "4px", padding: "6px", textAlign: "left"}}>
                                                    {f.name} ({f.result === '+' ? '+' : '-'})
                                                    <span style={{float: "right", cursor: "pointer", fontWeight: "bold"}}
                                                        onClick={() => this.removePhenotypeFilter(f.id)}>
                                                        x
                                                    </span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div style={{textAlign: "center", marginTop: "20px"}}>
                                    <button className="btn btn-info btn-block" onClick={this.searching}>
                                        BUSCAR
                                    </button>
                                </div>

                            </div>

                            {/* --- AREA DE TABLA (Ancho 8) --- */}
                            <div className="col-xs-12 col-sm-8">
                                <div className="col-xs-12" style={{textAlign: "center", margin: "10px 0"}}>
                                    <span style={{fontWeight: "bold", fontSize: "16px", textDecoration: "underline"}}>
                                        REPORTE DE FENOTIPOS IDENTIFICADOS
                                    </span>
                                </div>

                                <div className="col-xs-12 table-responsive">
                                    <table className="stripe hover row-border" width="100%" ref={el => this.el = el}>
                                    </table>
                                </div>

                                <div className="col-xs-12" style={{marginTop: "10px", fontSize: "14px", fontWeight: "bold"}}>
                                    Total Unidades: {this.state.count}
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

export default translate('translations')(PhenotypesIdentified);